import React from 'react';
import PropTypes from 'prop-types';

// Form custom (from scratch) — remplace le Form de reactstrap.
// Conserve le comportement du wrapper précédent : classe `app-form` par
// défaut, écrasée par un éventuel `className` passé en prop.
const Form = ({ children, innerRef, ...otherProps }) => {
  return (
    <form ref={innerRef} className="app-form" {...otherProps}>
      {children}
    </form>
  );
};

Form.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
};

export default Form;
